import React from 'react';
import { parseSanitizedHTML } from '../../utils/Helper';

import './Links.scss';

const Links = ({ links }) => {
  return (
    <div className="linksContainer">
      {links &&
        links.map((v, k) => {
          return (
            <div className="link mb-4" key={k}>
              <a href={v.url} target="_target" className="link__url">
                {v.title}
              </a>
              <div className="link__desc">{parseSanitizedHTML(v.description)}</div>
            </div>
          );
        })}
    </div>
  );
};

export default Links;
